export const COMMON_COMPONENTS_LOCALIZATION_SCOPE = 'common-components';
